import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslocoModule } from '@ngneat/transloco';
import { UserAvatarComponent } from '../user-avatar/user-avatar.component';
import { UserComponent } from './user.component';
import { ComponentsModule } from '../../../core/components/components.module';
import { SharedModule } from '../../../shared/shared.module';

@NgModule({
    declarations: [
        UserAvatarComponent,
        UserComponent
    ],
    imports: [
        ComponentsModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        SharedModule,
        TranslocoModule,
    ],
    exports: [
        UserAvatarComponent,
        UserComponent
    ]
})
export class UserModule {
}
